import { useDispatch } from 'react-redux';
import moment from 'moment';

import { MoveInPreSSDError } from 'errors/MoveInDateError';
import { MOVE_IN_VERIFY_ERROR_CODES, DATE_FORMAT } from 'config/app-config';
import {
  setError,
  setSuccess,
  setMoveInDate,
  setSupplyStartDate
} from 'state/move-in-date/move-in-date-slice';

export const useHandleMoveInVerifyError = () => {
  const dispatch = useDispatch();

  return (response) => {
    const { errors, data } = response;
    const ssdError = errors?.find(
      (error) => error.code === MOVE_IN_VERIFY_ERROR_CODES.MoveInPreSSDError
    );

    if (ssdError) {
      const supplyStartDate = moment(data?.supplyStartDate).utc(true);
      const newMoveInDate = moment(supplyStartDate, DATE_FORMAT, true)
        .add(1, 'days')
        .format(DATE_FORMAT);
      const error = new MoveInPreSSDError(ssdError);
      const moveInVerifySsdErrors = [error.toJson()];
      dispatch(setError(moveInVerifySsdErrors));
      dispatch(setSuccess(response));
      dispatch(setMoveInDate(newMoveInDate));
      dispatch(setSupplyStartDate(newMoveInDate));

      return moveInVerifySsdErrors;
    }

    return errors;
  };
};
